import { render, staticRenderFns } from "./DebtorDocuments.vue?vue&type=template&id=8830ae24&"
import script from "./DebtorDocuments.vue?vue&type=script&lang=js&"
export * from "./DebtorDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports